module.exports = __webpack_public_path__ + "static/fastphoto-3ec30a73cb408cc8c9dadc2d3bd12a41.png";